import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reduxForm} from 'redux-form';
import editUserValidation from './editUserValidation';
import * as UserActions from 'redux/modules/users'; 
import { routeActions } from 'react-router-redux';

import {Button, Row, Col, Table, Panel, Alert} from 'react-bootstrap';
import Select from 'react-select';
import _ from "underscore"

import './Users.css';

var MobileDetect = require('mobile-detect'); 

import { translate } from 'react-i18next';

@translate(['common'])

@connect(
  state => ({ 
  	created: state.users.created,  
  	saveError: state.users.saveError, 
  	saveSuccess: state.users.saveSuccess,
  	groups: state.groups.data,
  	loading: state.users.loading,
  	fiches:state.fiches.data
  }),
  dispatch => bindActionCreators({...UserActions, ...routeActions}, dispatch)
)
@reduxForm({
  form: 'editUserForm',
  fields: ['user.c_id', 'user.id', 'user.nom', 'user.prenom', 'user.societe', 'user.super_user', 
    'user.sites',
  	'user.fonction', 'user.login', 'user.password',
  	'group.groupList',
  	'user.telephone',
  	'mail[].id',
  	'mail[].address',
  	'mail[].panne_flag_debut'  ,
  	'mail[].panne_flag_fin'    ,
  	'mail[].panne_tempo'   ,
  	'mail[].usager_flag_debut' ,
  	'mail[].usager_flag_fin'   ,
  	'mail[].usager_tempo'  , 
  	'mail[].dispo_flag_debut',
  	'mail[].dispo_flag_fin'  ,
  	'mail[].dispo_tempo' ,
  	'mail[].cyclique_tempo' ,
  	'mail[].maintenance_tempo', 
  	'touched'],
  validate: editUserValidation,
  destroyOnUnmount: true
})

export default class UserForm extends Component {
  
  
  shPass(){
  	this.setState({passVisible:!this.state.passVisible})
  }
  
  constructor(props){
	super(props);
	this.state = {
		passVisible:false,
		expanded:true
	};
	this.shPass = this.shPass.bind(this);
  }
	
   
  
  componentDidMount(){
    var md = new MobileDetect(window.navigator.userAgent);
    
    if( md.tablet() || md.phone() ) {
      
      this.setState({expanded:false})
       
    }
  }
  
  componentWillUnmount(){
  	this.props.dispatch(UserActions.editStop(this.props.userId))
  }
  

  render() {
    const {      
      	user_info,
		editStop,
		fields:{user, mail, group, touched},
		formKey,
		handleSubmit,
		invalid,
		submitting,
		resetForm,
		createUser, 
		values,
		created,
		pristine,
		save,
		saveError, 
		saveSuccess,
		userId, 
		groups,
		user_emails, 
		urlParams,
		loading, 
		userGroups,
		t
    } = this.props; 

    const styles = require('containers/Users/AddUser.scss');    
    var error = false;

    if( saveError != false ) {

    	var error = (
  			<div className="alert alert-danger" role="alert">
				<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
				{saveError}&nbsp;

				<button type="button" className="btn btn-default"
					onClick={() => editStop(formKey)} 
					disabled={submitting}>
					<i className="fa fa-ban"/> {t("userForm.back_to_list")}
				</button>

  			</div>);
    }
    
    var success = false;

    if( saveSuccess == true ) {
      success = (
    		
  		<div className="alert alert-success" role="alert">
        	<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>

			{t("userForm.user_updated")}

        	&nbsp;&nbsp;
        	<button className="btn btn-default" type="button" onClick={() => editStop(formKey)}>
				{t("userForm.back_to_user_list")}
			</button> 
        </div>
        
    	);
    } else {
    	//var success = <span/>;
    }
    
    var pwd_glyph = this.state.passVisible ? <i onClick={()=>this.shPass()} className="glyphicon glyphicon-eye-close"/> : <i className="glyphicon glyphicon-eye-open" onClick={()=>this.shPass()}/>    		
    var pass_type = this.state.passVisible ? 'text' : 'password'
    		
    var mail_errors = 0
    	_.each(mail, (m)=>{
    		if(m.address.invalid == true || m.address.value == ''){ 
    			mail_errors++
    		}
    	})
    	 
    var canAddEmail = mail_errors == 0 && mail.length < 10 
     
    var pOptions = this.props.fiches.map((f)=>{ 
      return {"label":<div>{f.products.map((p)=><div>{p.identification_NUM_ASC}</div>)}</div>, "value":f.id, clearableValue:(user_info.role != 'user' || user_info.super_user == 1), disabled:(user_info.role.indexOf('user') > -1 && user_info.super_user == 0)} 
    })
    /*
    var pOptions = this.props.user_data.sites.map((s)=>{ 
			return {"label":<div>{s.phone} : {s.products?s.split('%').map((p)=><div>{p.split(':')[1]}</div>):''}</div>, "value":s.s_id, clearableValue:(user_info.role != 'user' || user_info.super_user == 1), disabled:(user_info.role.indexOf('user') > -1 && user_info.super_user == 0)} 
		})*/
    
    
    
    var tempoOptions = [{value:'test', 'label':'test'}]
    
    return ( 
    	<form autoComplete="testpedk" className="form-horizontal">
			<br/>
    		<div className="col-xs-12">
	    		
				<Row>
					<Col xs={12} md={6}>

						{/*<span> 
							<button type="button" className="btn btn-default btn-warning" 
								onClick={() => editStop(formKey)}
								disabled={submitting}>
									<i className="fa fa-ban"/> {t("main.cancel_edit")}
							</button>
						</span>
							
						<br/>
						<br/>
						*/}

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.nom.invalid ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("main.lastname")} *</label>

								<div className={'col-xs-12'+ ' col-md-' + (user.nom.invalid ? '5' : '8')}>
									<input type="text" className="form-control" placeholder="" {...user.nom}/>
								</div>
								{user.nom.invalid && <div className="col-xs-12 col-md-3 help-block">{user.nom.error}</div>}
							</div>
						</div>

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.prenom.invalid ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("main.firstname")} *</label>														
								<div className={'col-xs-12'+ ' col-md-' + (user.prenom.invalid ? '5' : '8')}>
									<input type="text" className="form-control" placeholder="" {...user.prenom}/>
								</div>
								{user.prenom.invalid && <div className="col-xs-12 col-md-3 help-block">{user.prenom.error}</div>}
							</div>
						</div>

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.societe.invalid ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("main.society")} *</label>
								<div className={'col-xs-12'+ ' col-md-' + (user.societe.invalid ? '5' : '8')}>
									<input type="text" className="form-control" placeholder="" {...user.societe}/>
								</div>
								{ user.societe.invalid && <div className="col-xs-12 col-md-3 help-block">{user.societe.error}</div>}
							</div>
							</div> 

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.fonction.invalid ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("userForm.fonction")}</label>
								<div className={'col-xs-12'+ ' col-md-' + (user.fonction.invalid ? '5' : '8')}>
									<input type="text" className="form-control" placeholder="" {...user.fonction}/>
								</div>
								{ user.fonction.invalid && <div className="col-xs-12 col-md-3 help-block">{user.fonction.error}</div>}
							</div> 
						</div>

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.login.touched && user.login.error ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">Login *</label>														
								<div className={'col-xs-12'+ ' col-md-' + (user.login.touched && user.login.error ? '5' : '8')}> 
									<div className="input-group">
										<input autoComplete="new-password7455" disabled={true} type="text" className="col-xs-8 form-control" placeholder="" {...user.login}/>
										<span className="input-group-addon">{'-usr'}</span>
									</div>
								</div> 
								{user.login.touched && user.login.error && <div className="col-xs-12 col-md-3 help-block">{user.login.error}</div>}
							</div>
						</div>

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.password.invalid ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("main.password")}</label>
								<div className={'col-xs-12'+ ' col-md-' + (user.password.invalid ? '5' : '8')}>
									<div className="input-group">
										<input autoComplete="new-password" type={pass_type} className="form-control" placeholder="" {...user.password}/>
										<span className="input-group-addon">{pwd_glyph}</span>
									</div>
								</div>
								{ user.password.invalid && <div className="col-xs-12 col-md-3 help-block">{user.password.error}</div>}
							</div>
						</div> 
						

						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.telephone.invalid ? ' has-error' : '')}>
									<label className="col-xs-12 col-md-3 control-label">{t("main.phone")}</label>
								<div className={'col-xs-12'+ ' col-md-' + (user.telephone.invalid ? '5' : '8')}>
									<input type="text" className="form-control" placeholder="" {...user.telephone}/>
								</div>
								{user.telephone.invalid && <div className="col-xs-12 col-md-3 help-block">{user.telephone.error}</div>}
							</div> 
						</div>
							
						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (user.super_user.touched && user.super_user.error ? ' has-error' : '')}>
								
								<label className="col-xs-12 col-md-3 control-label">{t("main.super_user")}</label>

								<div className={'col-xs-12'+ ' col-md-' + (user.super_user.touched && user.super_user.error ? '5' : '8')}>
									
									<input disabled={user_info.role=='user' && user_info.supervisor==0/*&& String(user_info.id) == String(userId)*/} 
										type="checkbox" className="" placeholder="" {...user.super_user} 
										onChange={(e)=>{
											user.super_user.onChange(!user.super_user.value)
											/*
											//On selectionne tous les groupes pour le SUPER USER
											if( user.super_user.value ) { 
												var ng = userGroups
											} else {
												var ng = groups.map((g)=>{
													return g.id;
												})
											}
											group.groupList.onChange(ng)*/
										}}/>	
									</div> 
								
								{user.super_user.touched && user.super_user.error && <div className="col-xs-12 col-md-3 help-block">{user.super_user.error}</div>}
							</div>
						</div>
							
							
						<div className="form-group" >
							<div className={'col-xs-12 col-md-12' + (user.sites.touched && user.sites.error ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("userForm.associated_products")}</label> 
								<div className={'col-xs-12'+ ' col-md-' + (user.sites.touched && user.sites.error ? '5' : '8')} >
									<Select style={{zIndex:100000 }} 
										allowCreate={false}
										clearable={(user.role != 'user' || user.super_user == 1)}
										name="form-field-name"
										options={pOptions}
										multi={true}
										{...user.sites}
										onBlur={() => user.sites.onBlur()} 
									/>
									<div style={{ marginTop: '5px' }}>
										<Button bsSize="xs" bsStyle="success" onClick={() => user.sites.onChange(pOptions.filter(o => !o.disabled).map(o => o.value))}>
											<i className="fa fa-check-square-o" /> {t("main.select_all")}
										</Button>
										{' '}
										<Button bsSize="xs" bsStyle="danger" onClick={() => user.sites.onChange([])}>
											<i className="fa fa-square-o" /> {t("main.deselect_all")}
										</Button>
									</div>
								</div>
							</div>
						</div>
						
						<div className="form-group">
							<div className={'col-xs-12 col-md-12' + (group.groupList.touched && group.groupList.error ? ' has-error' : '')}>
								<label className="col-xs-12 col-md-3 control-label">{t("main.groups")}</label>

								<div className={'col-xs-12'+ ' col-md-' + (group.groupList.touched && group.groupList.error ? '5' : '8')}>
									<Select style={{zIndex:9000 }}
										name="groupList"
										value="one"
										options={groups.map((g)=>{ return {"label":g.name, "value":g.id} })}
											multi={true}
										{...group.groupList}
											onBlur={() => group.groupList.onBlur(group.groupList.value)}
									/>
									<div style={{ marginTop: '5px' }}>
										<Button bsSize="xs" bsStyle="success" onClick={() => group.groupList.onChange(groups.map(g => g.id))}>
											<i className="fa fa-check-square-o" /> {t("main.select_all")}
										</Button>
										{' '}
										<Button bsSize="xs" bsStyle="danger" onClick={() => group.groupList.onChange([])}>
											<i className="fa fa-square-o" /> {t("main.deselect_all")}
										</Button>
									</div>
								</div>
							</div>
						</div>						      
					
					</Col>
					
					<Col xs={12} md={6}>
						
						<div className="col-xs-12">
							
							<div className="form-group">
								<fieldset>
									<legend>{t("main.emails")}</legend>
									{mail.map((email, emailIndex) => <div key={emailIndex}>
										<div className="col-xs-12 col-md-12">
											<Alert bsStyle='danger'>
												<i className="fa fa-info-circle" /> &nbsp;
												{t("userForm.email_alert_desc")}
												
											</Alert>
										</div>
				
									<div className="form-group">
									<div className={'col-xs-12 col-md-12' + (email.address.touched && email.address.error ? ' has-error' : '')}>
										<label className="col-xs-12 col-md-2 control-label">Email {emailIndex+1}</label>
												
										<div className={'col-xs-12'+ ' col-md-' + (user.password.invalid ? '5' : '8')}>

										<div className={emailIndex > 0 ? "input-group" : ''}> 

											<input autoComplete="new-password7455" type="text" className="form-control" placeholder="" {...email.address}/> 
												{emailIndex > 0 && 
													<span style={{'cursor':'pointer'}} className="input-group-addon"> <i className="fa fa-times text-danger" onClick={() => {
														mail.removeField(emailIndex)
														
														this.props.fields.touched.onChange(true);
														}}></i>
													</span>
												}
												</div>
											</div>

												
											<br/><br/>
													

											<div className="col-md-12 col-xs-12">
												<Panel collapsible defaultExpanded={true} expanded={true}  header={t("main.events")} onClick={()=>this.setState({expanded:!this.state.expanded})}>
													<div className="table-responsive">
														<Table striped bordered hover> 
															<thead>
																<tr> 
																<th style={{ verticalAlign:"middle"}}><div style={{width:"93px"}}>{t("main.events")}			</div></th>
																<th style={{ verticalAlign:"middle"}}><div style={{width:"105px"}}>{t("userForm.start_alert")}</div></th> 
																<th style={{ verticalAlign:"middle"}}><div style={{width:"82px"}}>{t("userForm.end_alert")}	</div></th>
																<th style={{ verticalAlign:"middle"}}><div style={{width:"127px"}}>{t("userForm.tempo_alert")}</div></th>
																</tr>									
															</thead>

															<tbody>
																<tr>
																	<td>{t("userForm.panne_appareil")}</td>
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.panne_flag_debut}/>
																	</td>
																	
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.panne_flag_fin} />
																	</td>
																	
																	<td>
																		<input style={{width:'50px', display:'inline'}} className="" type="number" {...email.panne_tempo} min="0" />
																		&nbsp;{t("userForm.days")}
																	</td>
																
																</tr>
																
																
																<tr> 
																	<td>{t("userForm.usager_bloque")}</td>
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.usager_flag_debut} />
																	</td>
																	
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.usager_flag_fin}/>
																	</td>
																	
																	<td>
																		<input style={{width:'50px'}} type="number" {...email.usager_tempo} min="0"/>&nbsp;
																		{t("userForm.hours")}
																	</td>
																</tr>    				                      
																
																<tr>
																	<td>{t("userForm.sts_indispo")}</td>
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.dispo_flag_debut} /> 
																	</td>
																	
																	<td>
																		<input type="checkbox" className="" placeholder="" {...email.dispo_flag_fin} />   
																	</td>
																	
																	<td>
																		<input style={{width:'50px'}} type="number" {...email.dispo_tempo} min="0"/>&nbsp;{t("userForm.days")}
																	</td>
																</tr>
																
																<tr>
															<td colSpan={4}>                                    
																{t("userForm.absence")} <input style={{width:'50px'}} type="number" {...email.maintenance_tempo} min="0"/> 
																&nbsp;{t("userForm.weeks")}
															</td>
														</tr> 
																
																
														<tr>
															<td colSpan={4}>    				                        
																{t("userForm.defaut_test")} &nbsp; <input type="checkbox" className="" placeholder="" {...email.cyclique_tempo} />    				                        
															</td>
														</tr> 

													</tbody> 
												</Table>
											</div>
										</Panel> 
					
									</div>
									{email.address.touched && email.address.error && <div className="col-xs-4 help-block">{email.address.error}</div>}
								</div>
							</div>
						</div>
					)}
								
					<div className={'form-group col-xs-12 col-md-12'}  style={{marginLeft:'0px'}} >			  			
										
						<Button disabled={!canAddEmail} bsStyle='info' type="button" onClick={() => {
							if(canAddEmail) { 
								mail.addField({contact_alert:false}) 
							}    						    	 
						}}><i/> {t("userForm.add_email")}
						</Button>    			              		          
					</div>
						
						
				</fieldset>
		
			</div> 

		</div>
	</Col>
			
</Row>
	  
	  
	{(error || success) && 
		<Row> 
			
			<div style={{width:'342px', maxWidth:'100%'}}>
				{error}
				{success}
			</div>
			<br/>

		</Row>
	 }			  
					
	<Row>

       <Col xs={12} md={6}>
         {!saveSuccess &&            
           <span> 
             <button type="button" className="btn btn-default btn-warning" 
               onClick={() => editStop(formKey)}
               disabled={submitting}>
                 <i className="fa fa-ban"/> {t("main.cancel_edit")}
             </button>&nbsp;&nbsp;
           </span> 
         }
         
         <button className="btn btn-success"
           onClick={handleSubmit(() => {
             
             delete user.sites.value
             save(values, urlParams, {user, mail, group}, user_emails, this.props.user_data.sites, userGroups) 
               .then((result) => {
                 if (result && typeof result.error === 'object') {
                   return Promise.reject(result.error);
                     }
                     
                     this.props.load(urlParams)
                   })  
               })}
               
 
               disabled={pristine || invalid || submitting}>
               <i className={'fa ' + (loading ? 'fa-cog fa-spin' : 'fa-cloud')}/> {t("main.save")}
         </button>
           
         &nbsp;&nbsp;
         
         <button type="button" className="btn btn-danger"
           onClick={resetForm}
           >
              Reset
         </button>

       </Col> 
     
     </Row>
     
     <br/><br/> 
			
	<Row> 
		<span> 
		<button type="button" className="btn btn-primary"
		onClick={() => editStop(formKey)}
		disabled={submitting}>
					<i className="fa fa-arrow-left"/> {t("main.back_to_list")}
			</button>
		</span> 
	</Row>

			
    </div> 
  </form> 
)}
}

